/* LUCHADOR® — Módulo promocional Mes de la Patria 2026
   Autocontenido y temporal: se apaga solo el 20-sep-2026 23:59 hora Chile.
   No toca assets/luchador.js. Para retirar la promo antes, basta borrar la
   línea que carga este archivo en layout/theme.liquid.

   v28: el pop-up y las tarjetas ahora llevan al producto real CONJUNTO CHILE
        (un solo SKU a $84.000 con $120.000 tachado), en vez de mandar a armar
        rashguard y short por separado. */
(function(){
  'use strict';

  var FIN = new Date('2026-09-21T02:59:59Z'); // 20 sep 23:59 Chile (UTC-3)
  if (new Date() > FIN) return;

  // Producto CONJUNTO CHILE – LUCHADOR® (10593379811616)
  var URL_CONJ = '/products/' + encodeURIComponent('conjunto-chile-luchador\u00ae');
  var VAR = { 'Rojo':'52344630870304', 'Azul':'52344631066912' }; // talla M de cada color

  var IMG_POP  = 'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPT_Image_11_sept_2026_03_59_35_p.m..png?v=1789153700';
  var IMG_AZUL = 'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPT_Image_12_sept_2026_11_39_13_a.m..png?v=1789223966';
  var IMG_ROJO = 'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPT_Image_12_sept_2026_11_39_10_a.m..png?v=1789223964';

  var CSS = ''
  + '#luch-page-promo{padding:0 0 4rem}'
  + '.lp-hero{background:#0a0a0a;color:#fff;padding:3.2rem 1.5rem 2.6rem;text-align:center}'
  + '.lp-kicker{font-size:0.62rem;font-weight:800;letter-spacing:0.32em;text-transform:uppercase;color:#d8342f;margin:0 0 0.9rem}'
  + '.lp-title{font-size:clamp(2.1rem,6vw,3.6rem);font-weight:900;letter-spacing:-0.02em;text-transform:uppercase;line-height:0.95;margin:0 0 1rem}'
  + '.lp-sub{font-size:0.95rem;color:#b5b5b5;max-width:520px;margin:0 auto 1.4rem;line-height:1.5}'
  + '.lp-timer{display:inline-block;border:1px solid #333;padding:0.6rem 1.1rem;font-size:0.68rem;font-weight:800;letter-spacing:0.16em;text-transform:uppercase;color:#fff}'
  + '.lp-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(300px,1fr));gap:1.6rem;max-width:1100px;margin:2.6rem auto 0;padding:0 1.5rem}'
  + '.lp-card{background:#fff;border:1px solid #e6e6e6;display:flex;flex-direction:column;text-decoration:none;color:inherit}'
  + '.lp-card img{width:100%;display:block;background:#fafafa}'
  + '.lp-card-body{padding:1.3rem 1.4rem 1.5rem}'
  + '.lp-card-name{font-size:1.02rem;font-weight:900;text-transform:uppercase;margin:0 0 0.15rem;color:#0a0a0a}'
  + '.lp-card-parts{font-size:0.72rem;color:#8a8a8a;margin:0 0 0.9rem}'
  + '.lp-prices{display:flex;align-items:baseline;gap:0.7rem;margin:0 0 0.35rem}'
  + '.lp-old{font-size:1.05rem;color:#a0a0a0;text-decoration:line-through}'
  + '.lp-new{font-size:1.7rem;font-weight:900;color:#0a0a0a;line-height:1}'
  + '.lp-save{display:inline-block;background:#d8342f;color:#fff;font-size:0.6rem;font-weight:800;letter-spacing:0.12em;text-transform:uppercase;padding:0.3rem 0.55rem;margin:0 0 1.1rem}'
  + '.lp-btn{display:block;width:100%;padding:1rem;background:#0a0a0a;color:#fff;border:none;font-size:0.78rem;font-weight:900;letter-spacing:0.13em;text-transform:uppercase;cursor:pointer;text-align:center;text-decoration:none}'
  + '.lp-btn:hover{background:#d8342f}'
  + '.lp-fine{max-width:700px;margin:2.4rem auto 0;padding:0 1.5rem;font-size:0.72rem;color:#8a8a8a;line-height:1.65;text-align:center}'
  + '#lp-pop{display:none;position:fixed;inset:0;z-index:100000;background:rgba(0,0,0,0.82);align-items:center;justify-content:center;padding:1rem}'
  + '#lp-pop.open{display:flex}'
  + '#lp-pop-box{background:#0a0a0a;color:#fff;max-width:430px;width:100%;max-height:92vh;overflow-y:auto;position:relative;text-align:center}'
  + '#lp-pop-box img{width:100%;display:block;cursor:pointer}'
  + '#lp-pop-in{padding:1.6rem 1.5rem 1.8rem}'
  + '#lp-pop-close{position:absolute;top:9px;right:12px;background:rgba(0,0,0,0.55);border:none;color:#fff;font-size:1.5rem;line-height:1;cursor:pointer;width:32px;height:32px;z-index:2}'
  + '#lp-pop .lp-title{font-size:1.6rem;margin-bottom:0.55rem}'
  + '#lp-pop .lp-sub{font-size:0.82rem;margin-bottom:1.1rem}'
  + '#lp-pop-skip{display:block;width:100%;margin-top:0.8rem;background:none;border:none;color:#8a8a8a;font-size:0.7rem;text-decoration:underline;cursor:pointer}'
  + '.lp-nav-link{color:#d8342f !important;font-weight:800 !important}';

  function money(n){ return '$' + Math.round(n).toLocaleString('es-CL'); }

  function urlColor(color){
    return VAR[color] ? (URL_CONJ + '?variant=' + VAR[color]) : URL_CONJ;
  }

  function diasRestantes(){
    var d = Math.ceil((FIN - new Date()) / 86400000);
    return d < 1 ? 1 : d;
  }

  function cardHTML(color, img){
    return ''
    + '<a class="lp-card" href="' + urlColor(color) + '">'
    +   '<img src="' + img + '" alt="Conjunto Chile ' + color + '" loading="lazy">'
    +   '<div class="lp-card-body">'
    +     '<p class="lp-card-name">Conjunto Chile ' + color + '</p>'
    +     '<p class="lp-card-parts">Rashguard Chile Oficial 2026–2027 + Short Chile</p>'
    +     '<div class="lp-prices"><span class="lp-old">' + money(120000) + '</span><span class="lp-new">' + money(84000) + '</span></div>'
    +     '<span class="lp-save">Ahorras ' + money(36000) + '</span>'
    +     '<span class="lp-btn">Comprar ahora</span>'
    +   '</div>'
    + '</a>';
  }

  function pageHTML(){
    return ''
    + '<div class="lp-hero">'
    +   '<p class="lp-kicker">18 de Septiembre</p>'
    +   '<h1 class="lp-title">Mes de la Patria</h1>'
    +   '<p class="lp-sub">Lleváte el conjunto oficial de Chile — rashguard más short — por ' + money(84000) + ' en vez de ' + money(120000) + '.</p>'
    +   '<span class="lp-timer">Termina el 20 de septiembre · quedan ' + diasRestantes() + ' días</span>'
    + '</div>'
    + '<div class="lp-grid">' + cardHTML('Rojo', IMG_ROJO) + cardHTML('Azul', IMG_AZUL) + '</div>'
    + '<p class="lp-fine">Conjunto compuesto por rashguard Chile Oficial 2026–2027 y short Chile del mismo color y talla. Promoción no acumulable con otros descuentos, vigente hasta el 20 de septiembre de 2026 a las 23:59 hora de Chile.</p>';
  }

  function popHTML(){
    return ''
    + '<div id="lp-pop-box">'
    +   '<button id="lp-pop-close" onclick="LUCHPROMO.cerrar()" aria-label="Cerrar">×</button>'
    +   '<img src="' + IMG_POP + '" alt="Conjunto Chile" onclick="LUCHPROMO.irAProducto()">'
    +   '<div id="lp-pop-in">'
    +     '<p class="lp-kicker">Mes de la Patria</p>'
    +     '<h2 class="lp-title">Conjunto Chile<br>' + money(84000) + '</h2>'
    +     '<p class="lp-sub">Rashguard más short, antes ' + money(120000) + '. Solo hasta el 20 de septiembre.</p>'
    +     '<a class="lp-btn" href="' + URL_CONJ + '">Comprar ahora</a>'
    +     '<button id="lp-pop-skip" onclick="LUCHPROMO.cerrar()">Seguir navegando</button>'
    +   '</div>'
    + '</div>';
  }

  var API = {
    cerrar: function(){
      var p = document.getElementById('lp-pop');
      if (p) { p.classList.remove('open'); document.body.style.overflow = ''; }
    },
    irAProducto: function(){ window.location.href = URL_CONJ; },
    irAPromo: function(){
      this.cerrar();
      if (window.LUCH && typeof LUCH.showPage === 'function') LUCH.showPage('promo');
      else window.location.href = '/?page=promo';
    }
  };
  window.LUCHPROMO = API;

  function montar(){
    if (document.getElementById('luch-page-promo')) return;

    var st = document.createElement('style');
    st.id = 'lp-css';
    st.textContent = CSS;
    document.head.appendChild(st);

    /* En la ficha del producto el SPA no monta las páginas internas, así que
       no hay dónde colgar la sección — y tampoco tiene sentido el pop-up:
       el visitante ya está donde lo queríamos llevar. */
    var ref = document.querySelector('.luch-page');
    if (!ref || !ref.parentElement) return;

    var pg = document.createElement('section');
    pg.className = 'luch-page';
    pg.id = 'luch-page-promo';
    pg.innerHTML = pageHTML();
    ref.parentElement.appendChild(pg);

    var pop = document.createElement('div');
    pop.id = 'lp-pop';
    pop.innerHTML = popHTML();
    pop.addEventListener('click', function(e){ if (e.target === pop) API.cerrar(); });
    document.body.appendChild(pop);

    /* Enlace en el menú: se inyecta desde acá para que desaparezca solo
       cuando la promo expire, sin tener que editar el menú. */
    var ul = document.querySelector('.luch-nav-links');
    if (ul && !ul.querySelector('[data-page="promo"]')) {
      var li = document.createElement('li');
      li.innerHTML = '<a class="lp-nav-link" href="/?page=promo" data-page="promo" onclick="LUCHPROMO.irAPromo();return false;">Mes de la Patria</a>';
      ul.insertBefore(li, ul.firstChild);
    }
    var mob = document.getElementById('luch-mobile-menu');
    if (mob && !mob.querySelector('[data-page="promo"]')) {
      var a = document.createElement('a');
      a.className = 'lp-nav-link';
      a.href = '/?page=promo';
      a.setAttribute('data-page', 'promo');
      a.textContent = 'Mes de la Patria';
      a.onclick = function(){ LUCHPROMO.irAPromo(); return false; };
      mob.insertBefore(a, mob.firstChild);
    }

    /* Si el visitante llegó directo a /?page=promo, LUCH ya corrió checkPage()
       antes de que existiera esta sección y cayó en home. Lo corregimos. */
    try {
      if (new URLSearchParams(window.location.search).get('page') === 'promo' && window.LUCH) {
        LUCH.showPage('promo');
        return;
      }
    } catch(e){}

    /* Pop-up: una sola vez por sesión y nunca encima de la propia promo. */
    try {
      if (sessionStorage.getItem('lp-visto') === '1') return;
      sessionStorage.setItem('lp-visto', '1');
    } catch(e){}

    setTimeout(function(){
      var sec = document.getElementById('luch-page-promo');
      if (sec && sec.classList.contains('active')) return;
      var p = document.getElementById('lp-pop');
      if (p) { p.classList.add('open'); document.body.style.overflow = 'hidden'; }
    }, 1800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(montar, 400); });
  } else {
    setTimeout(montar, 400);
  }
})();
